import menu from './menu'
import date from './date'
import tool from './tool'

export default {
  ...menu,
  ...date,
  ...tool
}
